module.exports = __webpack_public_path__ + "static/img/brand-third-bg-1.2f3fe0da.png";